function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgDesignerMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3.556 6.74 3.18-3.18M3.35 11.024c-.007.02-.007.045-.013.064a4.245 4.245 0 0 1-.56 1.831c-.324.554-.81 1.094-1.526 1.266 0 0-.286.083-.246.4.032.312.456.401.456.401s2.756.039 4.847-1.005m6.457-8.897 1.972-2.28a1.099 1.099 0 0 0-.102-1.532 1.074 1.074 0 0 0-1.52.101L11.15 3.47m-.896 9.966L15 15l-1.571-4.751-8.586-8.586a2.241 2.241 0 0 0-3.183 0 2.25 2.25 0 0 0 0 3.18l8.593 8.592Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
}))));
export default SvgDesignerMode;